import Logo from "../header/logo.component";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <style>{`
        .footer-root {
          border-top: 1px solid var(--border-subtle);
          padding: 20px 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: var(--space-3);
          background: var(--bg);
          font-family: var(--font-sans);
        }

        .footer-left {
          display: flex;
          align-items: center;
          gap: var(--space-4);
          flex-wrap: wrap;
        }

        .footer-brand {
          display: flex;
          align-items: center;
          gap: var(--space-2);
          font-family: var(--font-mono);
          font-size: 12px;
          color: var(--text-tertiary);
        }

        .footer-links {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .footer-link {
          font-family: var(--font-mono);
          font-size: 12px;
          color: var(--text-quaternary);
          text-decoration: none;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          transition: color var(--dur-fast) var(--ease-out);
        }

        .footer-link:hover { color: var(--text-secondary); }

        .footer-sep {
          width: 1px;
          height: 10px;
          background: var(--border-subtle);
        }

        .footer-disclaimer {
          font-size: 12px;
          color: var(--text-quaternary);
          font-family: var(--font-mono);
        }

        @media (max-width: 500px) {
          .footer-root {
            padding: 20px;
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>

      <footer className="footer-root">
        <div className="footer-left">
          <div className="footer-brand">
            <Logo size={14} />
            Max Stock Machine · Cascade Collective LLC
          </div>
          <div className="footer-links">
            <div className="footer-sep" />
            <Link to="/terms-of-service" className="footer-link">
              Terms
            </Link>
            <div className="footer-sep" />
            <Link to="/privacy-policy" className="footer-link">
              Privacy
            </Link>
            <div className="footer-sep" />
            <a
              href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}
              className="footer-link"
            >
              Contact
            </a>
          </div>
        </div>
        <span className="footer-disclaimer">Not financial advice.</span>
      </footer>
    </>
  );
};

export default Footer;
